/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';

/** Utilities for inferring context generics */

const DataContext = /*#__PURE__*/createContext({});
export default DataContext;